import Person from '@/common/interfaces/dto/Person';
import { RecaptchaResponse } from '@/forms/FormElements/Mixins/RecaptchaMixin';

export interface RecipientItem {
  Id: number;
  Name: string;
  Email: string;
}

export interface SecondStepModel extends RecaptchaResponse {
  Message: string;
  Person: Person;
  DestinationId: string;
  ItineraryId: string;
  DepartureId: string;
  Email: string;
  IsMe: boolean;
  IsBoth: boolean;
  IsFriends: boolean;
  Recipients: RecipientItem[];
  EmailSubscription: boolean;
  NewsletterSubscription: boolean;
  AnalyticsPayload?: string;
}

const formNames = {
  DestinationId: 'DestinationId',
  ItineraryId: 'ItineraryId',
  Date: 'DepartureId',
  Person: 'Person',
  Email: 'Email',
  IsMe: 'IsMe',
  IsBoth: 'IsBoth',
  IsFriends: 'IsFriends',
  Recipients: 'Recipients',
  Name: 'Name',
  Message: 'Message',
  EmailSubscription: 'EmailSubscription',
  NewsletterSubscription: 'NewsletterSubscription',
};

export const names = {
  ...formNames,
};

export interface getDropdownProps {
  destinationId?: number;
  itineraryId?: number;
  showloading?: boolean;
}